import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, LinearProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useDeleteFile } from '../hooks/useDeleteFile';
const StyledButton = styled(Button) `
  color: ${props => props.theme.palette.error.contrastText};
  background-color: ${props => props.theme.palette.error.main};
`;
const DocumentDeleteDialog = props => {
    var _a;
    const { file, open, onCancel, onSuccess } = props;
    const onSuccessRef = useRef(onSuccess);
    const [error, setError] = useState();
    const { data, isLoading, error: deleteError, del } = useDeleteFile(file.id);
    const label = file.isFolder ? 'folder' : 'file';
    const isInTrash = (_a = file.path) === null || _a === void 0 ? void 0 : _a.startsWith('Trash/');
    useEffect(() => {
        onSuccessRef.current = onSuccess;
    }, [onSuccess]);
    useEffect(() => {
        open && setError(undefined);
    }, [open]);
    useEffect(() => {
        var _a;
        if (!data) {
            return;
        }
        const label = data.isFolder ? 'Folder' : 'File';
        const action = isInTrash ? 'permanently deleted' : 'moved to Trash';
        const message = `${label} ${data.name} ${action}`;
        (_a = onSuccessRef.current) === null || _a === void 0 ? void 0 : _a.call(onSuccessRef, data, message);
    }, [data, isInTrash]);
    useEffect(() => {
        setError(deleteError);
    }, [deleteError]);
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: 'xs', open: open, onClose: onCancel },
        isLoading && React.createElement(LinearProgress, null),
        React.createElement(DialogTitle, null, isInTrash ? 'Confirm Permanent Delete' : 'Confirm Move to Trash'),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null, isInTrash ? (React.createElement(React.Fragment, null,
                "Are you sure you want to permanently delete the ",
                label,
                " \"",
                file.name,
                "\" and all its content? This action cannot be undone.")) : (React.createElement(React.Fragment, null,
                "Are you sure you want move the ",
                label,
                " \"",
                file.name,
                "\" and all its content to Trash?"))),
            error && React.createElement(Alert, { severity: 'error' }, error.message)),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: onCancel }, "Cancel"),
            React.createElement(StyledButton, { variant: 'contained', disabled: isLoading, onClick: () => del() }, "Delete"))));
};
export default DocumentDeleteDialog;
//# sourceMappingURL=DocumentDeleteDialog.js.map